var $23a92651c6957668$exports = {};
$23a92651c6957668$exports = {
  "alpha": "Alfa",
  "black": "siyah",
  "blue": "Mavi",
  "blue purple": "mavi mor",
  "brightness": "Parlakl\u0131k",
  "brown": "kahverengi",
  "brown yellow": "kahverengi sar\u0131",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "camg\xF6be\u011Fi",
  "cyan blue": "camg\xF6be\u011Fi mavi",
  "dark": "koyu",
  "gray": "gri",
  "grayish": "grimsi",
  "green": "Ye\u015Fil",
  "green cyan": "ye\u015Fil camg\xF6be\u011Fi",
  "hue": "Ton",
  "light": "a\xE7\u0131k",
  "lightness": "Canl\u0131l\u0131k",
  "magenta": "eflatun",
  "magenta pink": "eflatun pembe",
  "orange": "turuncu",
  "orange yellow": "turuncu sar\u0131",
  "pale": "solgun",
  "pink": "pembe",
  "pink red": "pembe k\u0131rm\u0131z\u0131",
  "purple": "mor",
  "purple magenta": "mor eflatun",
  "red": "K\u0131rm\u0131z\u0131",
  "red orange": "k\u0131rm\u0131z\u0131 portakal",
  "saturation": "Doygunluk",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " saydam");
  },
  "very dark": "\xE7ok koyu",
  "very light": "\xE7ok a\xE7\u0131k",
  "vibrant": "canl\u0131",
  "white": "beyaz",
  "yellow": "sar\u0131",
  "yellow green": "sar\u0131 ye\u015Fil"
};
export { $23a92651c6957668$exports as default };